var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_13403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.024 6.314L16.3763 4.66625C15.9466 4.2366 15.3753 4 14.7675 4H11.6755C10.174 4 8.94744 5.1414 8.78364 6.6H8.42549C6.81284 6.6 5.50049 7.91235 5.50049 9.525V16.675C5.50049 18.2877 6.81284 19.6 8.42549 19.6H12.9755C14.5881 19.6 15.9005 18.2877 15.9005 16.675V16.3169C17.3591 16.1531 18.5005 14.9265 18.5005 13.425V7.4632C18.5005 7.029 18.3308 6.6208 18.024 6.314ZM17.5645 6.77355C17.6971 6.90615 17.7848 7.07125 17.8245 7.24935H16.2248C15.6873 7.24935 15.2498 6.8119 15.2498 6.27435V4.72995C15.4975 4.8073 15.7276 4.93665 15.9161 5.12515L17.5638 6.7729L17.5645 6.77355ZM12.9748 18.9494H8.42484C7.17034 18.9494 6.14984 17.9289 6.14984 16.6744V9.52435C6.14984 8.26985 7.17034 7.24935 8.42484 7.24935H8.74984V13.4243C8.74984 15.037 10.0622 16.3494 11.6748 16.3494H15.2498V16.6744C15.2498 17.9289 14.2293 18.9494 12.9748 18.9494ZM15.5748 15.6994H11.6748C10.4203 15.6994 9.39984 14.6789 9.39984 13.4243V6.92435C9.39984 5.66985 10.4203 4.64935 11.6748 4.64935H14.5998V6.27435C14.5998 7.17005 15.3291 7.89935 16.2248 7.89935H17.8498V13.4243C17.8498 14.6789 16.8293 15.6994 15.5748 15.6994ZM15.8998 10.8243C15.8998 11.0038 15.7542 11.1494 15.5748 11.1494H13.9498V12.7744C13.9498 12.9538 13.8042 13.0993 13.6248 13.0993C13.4454 13.0993 13.2998 12.9538 13.2998 12.7744V11.1494H11.6748C11.4954 11.1494 11.3498 11.0038 11.3498 10.8243C11.3498 10.6449 11.4954 10.4994 11.6748 10.4994H13.2998V8.87435C13.2998 8.69495 13.4454 8.54935 13.6248 8.54935C13.8042 8.54935 13.9498 8.69495 13.9498 8.87435V10.4994H15.5748C15.7542 10.4994 15.8998 10.6449 15.8998 10.8243Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_13403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.001,
    height: 16,
    fill: "currentColor",
    transform: "translate(5.49951 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/Templates.54e96360196c867c36beb08505cac7e8.svg";
export { ForwardRef as ReactComponent };